import { Component, ReactNode } from "react";
import { StorageRouterProps } from "../StorageRouterProps";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { StorageLayout } from "../StorageLayout";
import { StorageEntities } from "../StorageEntities";
import AssignmentsTable from "../components/AssignmentsTable";

export interface StorageUserViewPageProps extends NSARouterMakerResult, StorageRouterProps { }

class StorageUserViewPage extends Component<StorageUserViewPageProps>
{
    override render(): ReactNode
    {
        return (
            <StorageLayout
                {...this.props}
                pages={{
                    entity: StorageEntities.storage_user(this.props),
                    view: {
                        ui: {
                            tab_page_view: {
                                tabs: {
                                    extra: {
                                        after_general: [
                                            {
                                                title: "Assignment",
                                                clicked: false,
                                                isVisible: (model) => !!model.id,
                                                getContent: (model) =>
                                                {
                                                    if (!model.id)
                                                        return null;
                                                    return (
                                                        <AssignmentsTable
                                                            {...this.props}
                                                            storage_user_id={model.id}
                                                        />
                                                    );
                                                },
                                            },
                                        ],
                                    },
                                },
                            },
                        },
                    }
                }}
            >
                <></>
            </StorageLayout>
        );
    }
}

export default StorageUserViewPage;